/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reverse_Rtl_Start_EndInputs */

const en_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse RTL Start and End`)
};

const fr_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inverser le début et la fin RTL`)
};

const de_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umgekehrter RTL-Start und -Ende`)
};

const it_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio e fine RTL inversi`)
};

const ru_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обратное начало и конец RTL`)
};

const es_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio y fin RTL inverso`)
};

const zh_cn2_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向 RTL 起始和结束`)
};

const ja_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆RTLの開始と終了`)
};

const hi_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवर्स आरटीएल प्रारंभ और समाप्ति`)
};

const pt_pt2_reverse_rtl_start_end = /** @type {(inputs: Reverse_Rtl_Start_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início e fim do RTL reverso`)
};

/**
* | output |
* | --- |
* | "Reverse RTL Start and End" |
*
* @param {Reverse_Rtl_Start_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reverse_rtl_start_end = /** @type {((inputs?: Reverse_Rtl_Start_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reverse_Rtl_Start_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reverse_rtl_start_end(inputs)
	if (locale === "de") return de_reverse_rtl_start_end(inputs)
	if (locale === "it") return it_reverse_rtl_start_end(inputs)
	if (locale === "ru") return ru_reverse_rtl_start_end(inputs)
	if (locale === "es") return es_reverse_rtl_start_end(inputs)
	if (locale === "zh-CN") return zh_cn2_reverse_rtl_start_end(inputs)
	if (locale === "ja") return ja_reverse_rtl_start_end(inputs)
	if (locale === "hi") return hi_reverse_rtl_start_end(inputs)
	if (locale === "pt-PT") return pt_pt2_reverse_rtl_start_end(inputs)
	return en_reverse_rtl_start_end(inputs)
});